const shortMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Ags', 'Sep', 'Okt', 'Nov', 'Des']
const fullMonth = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'Septempber', 'Oktober', 'November', 'Desember']
// const fullDay = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']

const dateFormatFull = (date = '') => {
    let d = new Date()

    if (date !== '') {
        d = new Date(date)
    }

    let month = '' + d.getMonth(),
        day = '' + d.getDate(),
        year = d.getFullYear();

    return [day, fullMonth[month], year].join(' ');
}

const dateFormatSort = (date = '') => {
    let d = new Date()

    if (date !== '') {
        d = new Date(date)
    }

    let month = '' + d.getMonth(),
        day = '' + d.getDate(),
        year = d.getFullYear();

    return [day, shortMonth[month], year].join('/');
}

const dateTimeFormat = (date = '') => {
    let d = new Date()

    if (date !== '') {
        d = new Date(date)
    }

    let month = '' + d.getMonth(),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = d.getHours(),
        minutes = d.getMinutes(),
        second = d.getSeconds();

        return `${[day, shortMonth[month], year].join(' ')} ${[String(hour).padStart(2, '0'), String(minutes).padStart(2, '0'), String(second).padStart(2,'0')].join(':')}`;
}

const dateDatabase = (date = '') => {
    let d = new Date()

    if (date !== '') {
        d = new Date(date)
    }

    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    return [year, month, day ].join('-');
}

const timeFormat = (date = '') => {
    let d = new Date()

    if (date !== '') {
        d = new Date(date)
    }

    let hour = d.getHours(),
        minutes = d.getMinutes(),
        second = d.getSeconds();

        return `${[String(hour).padStart(2, '0'), String(minutes).padStart(2, '0'), String(second).padStart(2,'0')].join(':')}`;
}

const dateTimeDatabase = (date = '') => {
    let d = new Date()

    if (date !== '') {
        d = new Date(date)
    }

    let month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = d.getHours(),
        minutes = d.getMinutes(),
        second = d.getSeconds();

    return `${[year, month, day ].join('-')} ${[String(hour).padStart(2, '0'), String(minutes).padStart(2, '0'), String(second).padStart(2,'0')].join(':')}`;
}

const timeHMFormat = (date = '') => {
    let d = new Date()

    if (date !== '') {
        d = new Date(date)
    }

    let hour = d.getHours(),
        minutes = d.getMinutes();

        return `${[String(hour).padStart(2, '0'), String(minutes).padStart(2, '0')].join(':')}`;
}

export {dateFormatFull, dateFormatSort, dateTimeFormat, dateDatabase, timeFormat, fullMonth, dateTimeDatabase, timeHMFormat}